import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { HttpError, HttpService } from 'src/toolkit';

import { TBrand, TBrandPayloadUpdate, TBrandResponse, adaptBrandFromResponse } from '../../types';
import { TSliceInitialState, useAppSelector } from '../../hooks';
import { BACKEND_ADMIN_BRAND } from '../../backend-paths';


export const brandUpdateApi = createAsyncThunk(
	`PUT/${BACKEND_ADMIN_BRAND}/:id`,
	(payload: TBrandPayloadUpdate, thunkApi) => {
		const { data, id } = payload;
		const path = `${BACKEND_ADMIN_BRAND}/${id}`;

		return HttpService.put<TBrandResponse>(path, data).then(result => {
			return adaptBrandFromResponse(result.data);
		}).catch((error: HttpError) => {
			return thunkApi.rejectWithValue({ ...error });
		});
	},
);

const initialState: TSliceInitialState<TBrand> = {
	item: undefined,
	isLoading: false,
	error: undefined,
};

export const brandUpdateSlice = createSlice({
	name: 'brandUpdateSlice',
	initialState,
	reducers: {
		clearBrandUpdate(state) {
			return { ...initialState };
		},
	},

	extraReducers: {
		[brandUpdateApi.pending.type]: (state) => {
			state.isLoading = true;
			state.error = undefined;
		},

		[brandUpdateApi.fulfilled.type]: (state, action: PayloadAction<TBrand>) => {
			state.isLoading = false;
			state.item = action.payload;
		},

		[brandUpdateApi.rejected.type]: (state, action: PayloadAction<HttpError>) => {
			state.isLoading = false;
			state.error = action.payload;
		},
	},
});

export const useBrandUpdateSelector = () => useAppSelector(state => state[brandUpdateSlice.name]);

export const { clearBrandUpdate } = brandUpdateSlice.actions;
